import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormField } from '../../../../models/form-field';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent implements OnInit {

  @Input() fg: FormGroup;
  @Input() f: FormField<any>;
  constructor() { }

  ngOnInit() { }

  get isChanged() { return this.fg.controls[this.f.key].touched || this.fg.controls[this.f.key].dirty; }
  get isValid() { return this.fg.controls[this.f.key].valid; }

}
